<template>
    <div class="flex flex-wrap gap-2 items-center font-bold text-lg">
        <NuxtLink :to="localePath('/all-categories')" class="text-breadcrumb">
            {{ $t("PartCategory.ViewAllCategories") }}
        </NuxtLink>
        <template v-for="category in props.categories" :key="category.Path">
            <i class="fass fa-chevron-right"></i>
            <NuxtLink :to="localePath('/part-category/' + category.Path)" class="text-breadcrumb">
                {{ category.Name }}
            </NuxtLink>
        </template>
        <slot />
    </div>
</template>
<script setup>
const localePath = useLangPath();
const props = defineProps({ categories: { type: Array, required: true } });
</script>
